import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { BeniImmobiliForm } from '../../../form/beni-immobili-form';
import { BenePignoratoImmobile } from '../../../models/immobili/bene-pignorato-immobile';
import { FormValidationService } from '../../../services/form-validation.service';

declare var closeModal: any;

@Component({
    selector: 'div [beni-immobili-add-form]',
  templateUrl: '../../../form/beni-immobili-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class BeniImmobiliAddComponent extends BeniImmobiliForm implements OnInit {
  idSezione: string;
  idFascicolo: string;
  beneImmobile: BenePignoratoImmobile;
  urlInsert: string;

  @Output()
  onReturn: EventEmitter<void> = new EventEmitter<void>();

  constructor( @Inject(OperationsService) operationService,
               @Inject(FormBuilder) campiForm,
               @Inject(HelpersService) helpers: HelpersService,
               @Inject(FormValidationService) formValidationService: FormValidationService) {
    super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Aggiungi beni immobili');
    this.isInserimento(true);
  }


  getBeneImmobile() {
    return this.beneImmobile;
  }

  getRequest(request: BenePignoratoImmobile) {
    this.operationService.addBeneImmobile(this.urlInsert, request, this.idFascicolo, this.idSezione).subscribe(response => this.datiBeneImmobile(response));
  }

  datiBeneImmobile(response) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(idSezione: string, idFascicolo: string, urlInsert: string, beneImmobile: BenePignoratoImmobile) {
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.beneImmobile = beneImmobile;
    this.populateSelect();
    this.createForm();
    this.urlInsert = urlInsert;
  }

  hasConvenzione(): boolean {
    return false;
  }

  hasTariffa(): boolean {
    return false;
  }

  hasDipendete(): boolean {
    return true;
  }

  hasMatricola(): boolean {
    return true;
  }

  hasAmbitiCompetenza(): boolean {
    return false;
  }
}
